export enum MockUserInviteStatus {
  Pending = 'Pending',
  Active = 'Active',
}

export enum UserRole {
  Admin = 'Admin',
  Dpo = 'Dpo',
  Editor = 'Editor',
  ReadOnly = 'ReadOnly',
}
export interface IMockData {
  id: string;
  email: string;
  confirmed: boolean;
  isAdmin: boolean;
  role: UserRole;
  inviteStatus: MockUserInviteStatus;
  lastLogin: string; // data
  createdAt: string; // data
}

const data: IMockData[] = [
  {
    id: '1',
    email: 'user1@email.mock',
    confirmed: true,
    isAdmin: true,
    role: UserRole.Admin,
    inviteStatus: MockUserInviteStatus.Active,
    lastLogin: new Date().toString(),
    createdAt: new Date().toString(),
  },
  {
    id: '2',
    email: 'user2@email.mock',
    confirmed: false,
    isAdmin: true,
    role: UserRole.Editor,
    inviteStatus: MockUserInviteStatus.Pending,
    lastLogin: new Date().toString(),
    createdAt: new Date().toString(),
  },
  {
    id: '3',
    email: 'user3@email.mock',
    confirmed: true,
    isAdmin: false,
    role: UserRole.ReadOnly,
    inviteStatus: MockUserInviteStatus.Active,
    lastLogin: new Date().toString(),
    createdAt: new Date().toString(),
  },
];

export default data;
